import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import ChevronIcon from 'assets/chevron-icon';

const PrevButton = ({ className, enabled, onClick }) => (
  <ButtonPrev
    aria-label='Previous'
    className={`${className} --left`}
    data-cy='carousel-prev-button'
    data-test='carousel-prev-button'
    disabled={!enabled}
    onClick={onClick}
  >
    <BackArrow onClick={onClick} width='100%' height='100%' />
  </ButtonPrev>
);

const NextButton = ({ className, enabled, onClick }) => (
  <ButtonNext
    aria-label='Next'
    className={`${className} --right`}
    data-cy='carousel-next-button'
    data-test='carousel-next-button'
    disabled={!enabled}
    onClick={onClick}
  >
    <ForwardArrow onClick={onClick} width='100%' height='100%' />
  </ButtonNext>
);

export const MemoizedPrevButton = memo(PrevButton);
export const MemoizedNextButton = memo(NextButton);

/* eslint-disable i18next/no-literal-string */
const CircleArrowStyles = css`
  height: 12px;
  width: 19px;
  fill: ${({ theme }) => theme.colors.grey[35]};
`;

const CircleContainer = css`
  background: ${({ theme }) => theme.colors.blueGrey[95]};
  border-radius: 50%;
  height: 54px;
  width: 54px;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.17);

  &:hover {
    background: ${({ theme }) => theme.colors.blueGrey[90]};
  }
`;

const sharedButtonStyles = css`
  background-color: transparent;
  position: absolute;
  z-index: 2;
  top: 50%;
  transform: translateY(-50%);
  outline: 0;
  border-radius: 35px;
  border: 0;
  width: ${(props) => (props.variant !== 'default' ? `50px` : `18px`)};
  height: ${(props) => (props.variant !== 'default' ? `50px` : `18px`)};
  ${(props) => (props.variant !== 'default' ? CircleContainer : '')};
  transition: opacity 0.25s, visibility 0.25s;
  display: none;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    display: block;

    &:not(:disabled) {
      cursor: pointer;
      opacity: 1;
      visibility: visible;
    }

    &:disabled {
      opacity: 0;
      visibility: hidden;
    }
  }
`;

const ButtonPrev = styled.button`
  ${sharedButtonStyles}
  left: 20px;

  @media (min-width: 1340px) {
    left: -7px;

    &.offers {
      left: -19px;
    }
  }
`;

const ButtonNext = styled.button`
  ${sharedButtonStyles}
  right: 0;

  @media (min-width: 1340px) {
    right: -27px;
  }
`;

const ForwardArrow = styled(ChevronIcon)`
  transform: rotate(-90deg);
  ${(props) => (props.variant !== 'default' ? CircleArrowStyles : '')};
  margin-left: 3px;
  width: 17px;
  height: 10px;
  margin-top: 7px;
`;

const BackArrow = styled(ChevronIcon)`
  transform: rotate(90deg);
  ${(props) => (props.variant !== 'default' ? CircleArrowStyles : '')};
  margin-left: -3px;
  width: 17px;
  height: 10px;
  margin-top: 7px;
`;
